export default __webpack_public_path__ + "static/media/6g.ce29e13c.svg";